//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import moment from "moment-timezone";

import _ from "js/underscore-mixins";

// Exposes session variables that are initialized on page load to various angular components (i.e. userTimeZone)
// Currently this is simply a proxy to a global crl8.session object (for legacy code), but in the future we can make it the one
// and only broker of session variables.
(function() {
  const API_CUSTOM_DATE_FORMAT = 'MM/DD/YYYY';

  angular.module('curalate').factory('SessionDateService', [
    '$http',
    '$rootScope',
    '$timeout',
    '$window',
    'DateTimeService',
    'PromiseService',
    'RestBaseUrl',
    function(
            $http,
            $rootScope,
            $timeout,
            $window,
            DateTimeService,
            PromiseService,
            RestBaseUrl,
        ) {
      if (!($window.crl8 && $window.crl8.session)) {
        throw new Error('window.crl8.session is not defined. Check SessionRestApiHelper.');
      }

      const session = $window.crl8.session;

      const dateTypeToSessionDateType = {
        today: DateTimeService.DateRangeConstants.TODAY,
        last24Hours: DateTimeService.DateRangeConstants.LAST_24_HOURS,
        last7Days: DateTimeService.DateRangeConstants.LAST_WEEK,
        last30Days: DateTimeService.DateRangeConstants.LAST_30_DAYS,
        last3Months: DateTimeService.DateRangeConstants.LAST_3_MONTHS,
        allTime: DateTimeService.DateRangeConstants.ALL_TIME,
        custom: DateTimeService.DateRangeConstants.CUSTOM,
      };
      const sessionDateTypeToDateType = _.invert(dateTypeToSessionDateType);

      return {
        sessionDateTypeToDateType,
        getDateRange() {
          let dr = { from: undefined, to: undefined }; // Default to All-Time date range.
          if (session.dateRange.type !== window.CURALATE.misc.DATE_RANGE_CONSTANTS.ALL_TIME) {
            dr = {
              from: session.dateRange.from,
              to: session.dateRange.to,
              alias: sessionDateTypeToDateType[session.dateRange.type]
            };
          }
          return dr;
        },
        setDateRange(dateRange) {
          const postBody = { dateRangeType: dateTypeToSessionDateType[dateRange.alias] };

          if (postBody.dateRangeType === window.CURALATE.misc.DATE_RANGE_CONSTANTS.CUSTOM) {
            postBody.startDate = moment(dateRange.startDate).format(API_CUSTOM_DATE_FORMAT);
            postBody.endDate = moment(dateRange.endDate).format(API_CUSTOM_DATE_FORMAT);
          }

          return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/date-range`, postBody)).then((response) => {
            session.dateRange.from = response.startDate;
            session.dateRange.to = response.endDate;
            session.dateRange.type = postBody.dateRangeType;

                        // Global callbacks for legacy, non angular components
            CURALATE.datepicker.onChangeCallbacks.forEach(cb => cb(session.dateRange));

            return session.dateRange;
          }).then(() => {
                        // Run this in a timeout so $location doesn't flip out (ref: DEV-25786)
            $timeout(() => {
                            // Update the date range override vars if we're in override mode
              if (session.dateRange.isOverrideActive) {
                CURALATE.misc.refreshDateParams();
              }

              $rootScope.$emit('dateRangeChanged', session.dateRange.from, session.dateRange.to);
            });

            return session.dateRange;
          });
        },
      };
    }]);
})();
